// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-text[data-v-8660bb36]{line-height:1.2}.h-100[data-v-8660bb36]{height:100%!important}[dir] .mb-3[data-v-8660bb36]{margin-bottom:1rem!important}[dir] .pb-0[data-v-8660bb36]{padding-bottom:0!important}", ""]);
// Exports
module.exports = exports;
